export default __webpack_public_path__ + "static/media/user-journey-img2.b4743779.svg";